import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class MaskedInput extends React.Component<MaskedInputProps, any>{
    private _maskTextBoxRef: any;
    private _maskTextBox: kendo.ui.MaskedTextBox;


    private _handleChange = (e) => {
        this.props.onChange(this.props.field, this._maskTextBox.value(), this._maskTextBox.raw());
    }

    private _getRules = (fieldRules: StringKeyDictionary<string>) => {
        if (!Helper.hasValue(fieldRules)) {
            return null;
        }

        const rules = {};
        for (let key in fieldRules) {
            let rule = fieldRules[key];
            if (rule[0] === "/" && rule[rule.length - 1] === "/") {
                rule = rule.substr(1, rule.length - 2);
            }
            rules[key] = new RegExp(rule);
        }

        return rules;
    }


    componentDidMount() {
        this._maskTextBox = $(this._maskTextBoxRef).kendoMaskedTextBox({
            mask: this.props.field.mask,
            value: this.props.value,
            change: this._handleChange,
            rules: this._getRules(this.props.field.rules)
        }).data("kendoMaskedTextBox");
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== this._maskTextBox.value()) {
            this._maskTextBox.value(this.props.value);
        }
    }

    componentWillUnmount() {
        this._maskTextBox.destroy();
    }

    render() {
        return (
            <input ref={(r) => this._maskTextBoxRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} readOnly={this.props.disabled} data-label={this.props.field.name} />
        );
    }
}


export interface MaskedInputField extends BaseField {
    mask: string;
    returnRaw?: boolean;
    rules?: StringKeyDictionary<string>;
}

export interface MaskedInputProps extends BaseComponentProps {
    field: MaskedInputField;
}